import axios from 'axios';

/**
 * @typedef {object} ReshipFulfillmentPlanRequest
 * @property {string} salesOrderId - Sales order id to create the new shipment for
 * @property {string} fulfillmentPlanId - Fulfillment plan id to copy the shipment from
 */

/**
 * @param {ReshipFulfillmentPlanRequest} request
 * @returns {Promise<AxiosResponse<any>>}
 */
export const reshipFulfillmentPlan = async (request) => {
  return axios.post('/fulfillmentplan/reship', request);
};
